// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__2TxNM","shimmer":"styles_shimmer__3MMGN","skeletonItem":"styles_skeletonItem__1k-_A"};